import { FC, memo } from 'react'
import { useAddCustomerMutation } from 'modules/customer/api'
import { CustomerAddForm } from 'modules/customer/components'
import { handleFetchResponse } from 'src/api/errors'

import { isSoleLegal } from '../../helpers'
import { CustomerAddFormFields } from '../CustomerAddForm/constants'
import { CustomerAddModalProps } from './types'

const CustomerAddModal: FC<CustomerAddModalProps> = (props) => {
  const {
    onClose,
    refetch,
    contactId,
    handleAttach,
    handleSelectValue,
    setIsContactsByCustomerList,
    setActiveCustomerId,
    setActiveCustomer,
    setIsActiveCustomerAddContactAccess,
    storeKey
  } = props

  const [addCustomer, { isLoading: isCustomerLoading }] = useAddCustomerMutation()

  const submitCustomer = async (rawPayload: CustomerAddFormFields) => {
    const { company, companySuggestorDisabled, addressSuggestorDisabled, ...payload } = rawPayload

    const isIp = isSoleLegal(company.inn)
    const isActiveManualEntryAddress = (isIp && addressSuggestorDisabled) || companySuggestorDisabled

    const payloadAddress = isActiveManualEntryAddress
      ? {
          address: {
            zipCode: payload.address.zipCode,
            localityName: payload.address.localityName,
            street: payload.address.street,
            house: payload.address.house,
            flat: payload.address.flat || undefined
          },
          legalAddress: undefined
        }
      : {
          legalAddress: isIp ? payload.address.value : company.address,
          address: undefined
        }
    const selectedOptionsPayload = companySuggestorDisabled
      ? {
          ...payload,
          dataSource: 'user',
          kpp: isIp ? company.kpp || undefined : company.kpp,
          inn: company.inn,
          name: company.value,
          ...payloadAddress
        }
      : {
          ...payload,
          dataSource: isActiveManualEntryAddress ? 'user' : 'auto',
          inn: company.inn,
          kpp: company.kpp,
          name: company.value,
          ...payloadAddress
        }
    // @ts-ignore
    const res = await addCustomer(selectedOptionsPayload).then(
      handleFetchResponse(
        (response) => {
          if (handleSelectValue) {
            onClose && onClose()
            handleSelectValue(response)
          }
          if (setIsContactsByCustomerList) {
            setIsContactsByCustomerList(true)
            // @ts-ignore
            setActiveCustomerId && setActiveCustomerId(response.id)
            setActiveCustomer &&
              setActiveCustomer({
                name: response.name,
                inn: response.inn,
                kpp: response.kpp
              })
            // @ts-ignore
            setIsActiveCustomerAddContactAccess && setIsActiveCustomerAddContactAccess(response.access.addContact)
            onClose && onClose()
          }
          // @ts-ignore
          handleAttach(contactId, response.id)
          setTimeout(() => {
            onClose && onClose()
            refetch && refetch()
          }, 0)
        },
        (errors: any) => {
          if (errors.legalAddress) {
            const formatNameErrors = { address: errors.legalAddress }
            delete errors.legalAddress

            return { ...formatNameErrors, ...errors }
          }

          return errors
        }
      )
    )

    // TODO подумать как сделать лучше
    const keysForTransform = ['inn', 'legalAddress', 'kpp', 'value']
    const companyErrorsTransformed = keysForTransform.reduce<Record<string, { title: string; path?: string }>>(
      (acc, key) => {
        if (res && res[key]) {
          acc[`company.${key}`] = { ...res[key] }
          delete res[key]
        }

        return acc
      },
      {}
    )

    if (res && Object.keys(companyErrorsTransformed).length) {
      const firstCompanyError = { company: companyErrorsTransformed[Object.keys(companyErrorsTransformed)[0]] }

      return { ...res, ...firstCompanyError, ...companyErrorsTransformed }
    }

    return { ...res, ...companyErrorsTransformed }
  }

  return (
    <CustomerAddForm
      isCustomerLoading={isCustomerLoading}
      onClose={onClose}
      storeKey={storeKey}
      // @ts-ignore
      submitCustomer={submitCustomer}
    />
  )
}

export default memo(CustomerAddModal)
